import React from "react";
import { Link as RouterLink } from "react-router";
import Box from "@mui/material/Box";
import CompanyLabelsLogo from "./CompanyLabelsLogo";
import useAuth from "../hooks/useAuth";
import useDashboardLink from "../hooks/useDashboardLink";

export default function ShoppingHeaderLogo({ project }) {
  const { user } = useAuth();
  const { labelsLogoUrl, secondaryLogoUrl } = user.company;
  const dashboardLink = useDashboardLink();
  const isGuest = user.role === "guest";
  const homeLink = isGuest ? "/login" : dashboardLink;

  const mainLogoUrl = project?.id
    ? project?.selectedMainLogoUrl || labelsLogoUrl
    : user.mainLogoUrl || labelsLogoUrl;

  const secondaryLogoDisplayUrl = project?.id
    ? project?.customerLogoUrl
    : secondaryLogoUrl || user.customerLogoUrl;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <RouterLink to={homeLink} style={{ textDecoration: "none" }}>
        <CompanyLabelsLogo logoUrl={mainLogoUrl} />
      </RouterLink>
      {secondaryLogoDisplayUrl && (
        <>
          <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "rgba(0, 0, 0, 0.12)",
            }}
          />
          <Box display="flex" alignItems="center">
            <Box
              component="img"
              src={secondaryLogoDisplayUrl}
              alt={project ? "Project logo" : "Customer logo"}
              sx={{ maxHeight: 40, maxWidth: 120, objectFit: "contain", mixBlendMode: "multiply" }}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
